type Props = {
  initials: string;
  gradient: string;
  size?: number;
  className?: string;
};

export function ProjectIcon({ initials, gradient, size = 44, className = '' }: Props) {
  return (
    <div
      className={`inline-flex items-center justify-center shrink-0 ${className}`}
      style={{
        width: size,
        height: size,
        borderRadius: Math.round(size * 0.28),
        background: gradient,
        color: '#fff',
        fontWeight: 800,
        fontSize: Math.round(size * 0.32),
        letterSpacing: '0.02em',
        lineHeight: 1,
        boxShadow: '0 4px 14px rgba(0,0,0,0.35)',
        fontFamily: 'var(--font-sans), system-ui, sans-serif',
      }}
      aria-hidden="true"
    >
      {initials}
    </div>
  );
}
